import { Component, Inject } from '@angular/core';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '../services/common.service';
import { LocalStorageSettingsService } from './../../shared/services/local-storage-settings.service';

export interface ImportZipDialogData {
    data: any;
}

@Component({
    selector: 'app-import-zip',
    imports: [
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule
],
    template: `
   <div style="display: flex; flex-direction: column; height: 100%; padding: 0px 0px; box-sizing: border-box;">
    <div class="agGridOuterDiv" style="margin-bottam: 40px;" >
  <label i18n="@@spmsUserReg"
         class="textColour"
         style="
           display:inline-block;
           font-weight:500;
           font-size:1.2rem;
           border-bottom:2px solid #333;

         ">
   Import {{this.importTypeUI}}
  </label>
</div>
    <!-- Upload ZIP File -->
    <div style="display: flex; align-items: center; gap: 10px; margin-top: 25px;">
      <label style="font-weight: 500; min-width: 180px; white-space: nowrap;">
        Upload ZIP File For Import:
      </label>

      <!-- File name display -->
      <mat-form-field appearance="outline" style="width: 280px; margin: 0;">
        <mat-label>Choose File</mat-label>
        <input matInput placeholder="Choose File" [value]="fileName" readonly>
      </mat-form-field>

      <!-- Paperclip icon -->
      <label for="zipUpload"
        style="cursor: pointer; display: flex; align-items: center; justify-content: center;
               width: 32px; height: 32px; border-radius: 50%; background-color: white;
               border: 1px solid #ddd; box-shadow: 2px 2px 5px rgba(0,0,0,0.2);
               margin-left: 5px;">
        <em class="fas fa-paperclip" style="color: black; font-size: 14px;"></em>
        <input id="zipUpload" type="file" accept=".zip"
               (click)="resetFileInput($event)" (change)="onZipFileSelected($event)"
               style="display: none;">
      </label>
    </div>

    <div style="flex: 1;"></div>

    <!-- Save & Cancel Buttons -->
    <div style="
      display: flex;
      justify-content: flex-end;
      gap: 16px;
      margin-top: 20px;
      padding: 8px 8px 0 8px;
    ">

      <!-- Save -->
      <button
        type="button"
        (click)="confirmAndUpload()"
        class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        style="
          color: white;
          font-weight: 500;
          padding-left: 75px;
          padding-right: 75px;
        "
        [style.background-color]="backgroundColorButton"
        [disabled]="!file">
        Save
      </button>

      <!-- Cancel -->
      <button
        type="button"
        (click)="cancelUpload()"
        class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        style="
          color: {{ backgroundColorButton }};
          font-weight: 500;
          background-color: white;
          border: 1px solid {{ backgroundColorButton }};
          padding-left: 75px;
          padding-right: 75px;
        ">
        Cancel
      </button>
    </div>
  </div>
  `
})
export class ImportZipComponent {
    file: File | null = null;
    fileName = '';
    tenantId: string;
    tableName: string;
   importType: string;
   importTypeUI: string;
    backgroundColorButton = this.localStorageSettings.getSettings('ColorA') || '#49a3ff';

    constructor(
        private commonService: CommonService,
        private localStorageSettings: LocalStorageSettingsService,
        private snackbar: MatSnackBar,
        private spinner: NgxUiLoaderService,
        private dialogRef: MatDialogRef<ImportZipComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit(): void {
      
      console.log(this.tableName);
      console.log(this.data.tablename)
      console.log(this.data)
      if (this.data.tablename =="administration"){
        this.importType = "administration";
        this.importTypeUI ="Administration"
      } else if (this.data.tablename == "Reports"){
        this.importType = "Reports";
        this.importTypeUI = "Reports"
      } else  {
        this.importType = "snapshot";
        this.importTypeUI = "Snapshot"
      }
        console.log('Dialog data:', this.data);
        this.tableName = this.data?.tablename || 'mapping_versions';
        console.log('Tenant ID:', this.tenantId, 'Table Name:', this.tableName);

        if (this.data.tenantid != undefined) {
            this.tenantId = this.data.tenantid
        } else {
            this.tenantId = localStorage.getItem("dnsName");

        }
    }

    resetFileInput(event: any): void {
        event.target.value = null;
    }

    onZipFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) return;

        const file = input.files[0];
        console.log('Selected ZIP file:', file);

        if (!file.name.endsWith('.zip')) {
            this.snackbar.open('Please select a valid ZIP file (.zip)', 'OK', { duration: 5000 });
            input.value = '';
            return;
        }

        this.file = file;
        this.fileName = file.name;
    }

  confirmAndUpload(): void { 
    if (!this.file) {
      this.snackbar.open('Please select a ZIP file first.', 'OK', { duration: 4000 });
      return;
    }

    if (!confirm('Do you want to import this ZIP file?')) return;

    // 🔍 First check if any imports are already in progress
    this.commonService.retrieveImporExporttHistory(this.tenantId).subscribe(
      (response) => {
        console.log(response);

        const hasInProgress = Array.isArray(response)
          ? response.filter(
            (item: any) =>
              item.status === 'In Progress' && item.tableName === 'mapping_versions'
          )
          : [];

        if (hasInProgress.length > 0) {
          this.cancelUpload();
          this.snackbar.open(
            `Import can't be initiated. Please initiate once the existing import completes.`,
            'OK',
            { duration: 5000 }
          );
          return; //  Stop execution here
        }

        //  If no "In Progress" import found, continue import
        this.snackbar.open('Importing ZIP file is in progress... Please wait!', 'OK', {
          duration: 3000,
        });

        this.commonService.importZipFile(this.tenantId, this.file,this.importType).subscribe(
          (response) => {
            console.log('Import response:', response);
            this.snackbar.open('ZIP file import is in Progress!', 'OK', {
              duration: 5000,
            });
            this.dialogRef.close(true);
          },
          (error) => {
            console.error('Error importing ZIP file:', error);
            this.snackbar.open('Error importing ZIP file.', 'OK', { duration: 5000 });
          }
        );

        // optional cleanup
        this.spinner.stop();
        this.file = null;
        this.fileName = '';
      },
      (error) => {
        console.error('Error retrieving import history:', error);
        this.snackbar.open('Error checking import history.', 'OK', { duration: 5000 });
      }
    );
  }



    cancelUpload(): void {
        this.file = null;
        this.fileName = '';
        this.dialogRef.close(false);
    }
}
